<div class="content-parametrics card-template p-3" *ngIf="pond_id" style="border-radius: 0">
  <div class="d-flex justify-content-between mb-3">
    <b>{{ "feed.recomended-food" | translate }}</b>

    <div
      class="optio-section bg-primary"
      placement="auto"
      [ngbPopover]="tooltipActions"
      #trecomded="ngbPopover"
      (click)="trecomded.open()"
      triggers="manual"
      container="body"
      [autoClose]="'outside'"
      [ngClass]="{'d-none': view === 'equation'}"
      popoverClass="principal-tooltip m-0"
    >
      <em class="fa fa-ellipsis-h"></em>
    </div>
    <ng-template #tooltipActions>
      <div class="tooltip-pond">
        <div class="title">
          <p class="m-0">{{ "feed.recomended-food" | translate }}</p>
        </div>

        <div class="section" *ngIf="view === 'tray'" [routerLink]="['/charolas', pond_id]">
          {{ "view-fuzzy-logic.go-to-trays" | translate }}
        </div>

        <ng-container *ngIf="view === 'sensors'">
          <div class="section" (click)="viewChart()">
            {{ "view-fuzzy-logic.feeding-behavior" | translate }}
            <div
              class="spinner-border"
              role="status"
              *ngIf="loading_graph"
              style="height: 15px; width: 15px"
            >
              <span class="visually-hidden"></span>
            </div>
          </div>

          <div class="section" (click)="viewFeedingReportsFuzzyLogic()">
            {{ "view-fuzzy-logic.ai-reports" | translate }}
            <div
              class="spinner-border"
              role="status"
              *ngIf="loading_reports"
              style="height: 15px; width: 15px"
            >
              <span class="visually-hidden"></span>
            </div>
          </div>

          <div
            class="section"
            *ngIf="globalFunction.validateSoloAdmin()"
            (click)="navigateFuzzyLogic()"
          >
            {{ "view-fuzzy-logic.feeding-projection" | translate }}
          </div>
        </ng-container>

        <div class="action-cancel" (click)="trecomded.close()">
          <small> {{ "general.cancel" | translate }}</small>
        </div>
      </div>
    </ng-template>
  </div>

  <nav class="tabs">
    <a class="tab-item" [class.active]="view === 'sensors'" (click)="view = 'sensors'"> AI </a>
    <!--   <a
      class="tab-item"
      [class.active]="view === 'equation'"
      (click)="view = 'equation'"
    >
      Nas 2025
    </a> -->
    <a class="tab-item" [class.active]="view === 'tray'" (click)="view = 'tray'"> {{ "clients.pond.tray.tray-singular" | translate }} </a>
  </nav>
</div>
<div>
  <div class="p-4" *ngIf="loading_feeding.view">
    <app-loading-time
      [type]="2"
      [url]="loading_feeding.url"
      [petition]="loading_feeding.view"
    ></app-loading-time>
  </div>
  <ng-container [ngSwitch]="view" style="height: 100px" *ngIf="!loading_feeding.view">
    <!-- CHAROLAS -->

    <div class="content" *ngSwitchCase="'tray'">
      <ng-container *ngIf="!loading_feeding.view">
        <div>
          <p>{{tray_data.tray_record}}u</p>
          <small>{{ "view-fuzzy-logic.tray-throw" | translate }}</small>
        </div>
        <div>
          <p>{{tray_data.percent | percent}}</p>
          <small>{{ "view-fuzzy-logic.percentage" | translate }}</small>
        </div>
        <div class="flex-column text-center">
          <p class="center">
            {{tray_data.recommended ? tray_data.recommended.toFixed(2) : 0}}kg
            <i
              *ngIf="tray_data.recommended > 0"
              class="span-circle"
              (click)="recomendation(tray_data.recommended)"
            >
              <em class="fa fa-plus"></em>
            </i>
          </p>
          <small>{{ "view-fuzzy-logic.recommended-kgs" | translate }}</small>
        </div>
      </ng-container>
    </div>
    <div class="content" *ngSwitchCase="'equation'">
      <ng-container *ngIf="diffuse_logic">
        <div>
          <p>{{diffuse_logic.weight ? diffuse_logic.weight.toFixed(2) : 0}}g</p>
          <small>{{ "clients.plantings.individual.size" | translate }}</small>
        </div>
        <div class="flex-column text-center">
          <p class="center">
            {{diffuse_logic.recommendation ? diffuse_logic.recommendation.toFixed(2) : 0}}kg
            <i
              class="span-circle"
              *ngIf="diffuse_logic.recommendation > 0"
              (click)="recomendation(diffuse_logic.recommendation)"
            >
              <em class="fa fa-plus"></em
            ></i>
          </p>
          <small>{{ "view-fuzzy-logic.recommended-kgs" | translate }}</small>
        </div>
      </ng-container>
    </div>
    <div class="d-flex flex-column" *ngSwitchCase="'sensors'">
      <div class="content-AI mt-3" *ngIf="feedingReport && feedingReport.fuzzy_logic_update">
        <!-- arriba izquierda -->
        <div class="item">
          <p>
            {{ feedingReport.fuzzy_logic_update && feedingReport.fuzzy_logic_update.water_temp !=
            null ? feedingReport.fuzzy_logic_update.water_temp : 'n/a' }} °C
          </p>
          <small>{{ "alerts.parametry.temperature" | translate }}</small>
        </div>

        <!-- arriba derecha -->
        <div class="item">
          <p placement="top" [ngbTooltip]="feedingReport.fuzzy_logic_update.modifier">
            {{ feedingReport.fuzzy_logic_update && feedingReport.fuzzy_logic_update.modifier != null
            ? (feedingReport.fuzzy_logic_update.modifier | number: '1.0-2') : 'n/a' }} %
          </p>
          <small>{{ "view-fuzzy-logic.adjustment" | translate }}</small>
        </div>

        <!-- abajo izquierda -->
        <div class="item">
          <p>
            {{ feedingReport.fuzzy_logic_update && feedingReport.fuzzy_logic_update.oxygen_level !=
            null ? feedingReport.fuzzy_logic_update.oxygen_level : 'n/a' }} mg/L
          </p>
          <small>{{ "alerts.parametry.oxygen" | translate }}</small>
        </div>

        <!-- abajo derecha -->
        <div class="item">
          <p>{{ sendKg(feedingReport) }}</p>
          <small>{{ "view-fuzzy-logic.kg-sent" | translate }}</small>
        </div>
      </div>
      <div class="d-flex justify-content-center align-items-center pt-3 pb-3">
        <ng-container
          *ngIf="feedingReport && feedingReport.fuzzy_logic_update && feedingReport.fuzzy_logic_update.created_at; else notDate"
        >
          <span class="m-0" *ngIf="feedingReport.fuzzy_logic_update">
            {{ "view-fuzzy-logic.last-adjustment" | translate }}: {{ feedingReport.fuzzy_logic_update.created_at | date:"d 'de' MMMM,
            h:mma" : 'es' }}
          </span>
        </ng-container>
        <ng-template #notDate> <span>{{ "view-fuzzy-logic.no-adjustment" | translate }}</span></ng-template>
      </div>
    </div>
  </ng-container>
</div>

<ng-template #graph_sensor>
  <div class="modal-header d-flex bg-primary p-2 align-items-center text-center">
    <div class="text" style="width: -webkit-fill-available">
      <h3 class="m-0">{{ "view-fuzzy-logic.ration-behavior-graph" | translate }}</h3>
    </div>
    <h3 class="m-0 c-pointer" (click)="Modal(graph_sensor, 'hide')">&times;</h3>
  </div>

  <div class="modal-body">
    <div class="filter-container mb-3">
      <span>{{ "view-fuzzy-logic.filter-by-day" | translate }}</span>
      <form [formGroup]="timeGroup" (submit)="generateQuery(timeGroup.value)">
        <div class="flex-content">
          <div class="flex-group align-items-center">
            <div class="flex-item">
              <label class="m-0 center gap-6">
                <input
                  type="radio"
                  formControlName="dateOption"
                  value="today"
                  (change)="setValueToday();"
                />
                {{ "clients.client-notifications.today" | translate }}
              </label>
            </div>
            <div class="flex-item">
              <label class="m-0 center gap-6">
                <input
                  type="radio"
                  formControlName="dateOption"
                  value="yesterday"
                  (change)="setValueYesterday();"
                />
                {{ "view-fuzzy-logic.yesterday" | translate }}
              </label>
            </div>
            <div class="flex-item">
              <label class="m-0 center gap-6">
                <input type="radio" formControlName="dateOption" value="other" />
                {{ "view-fuzzy-logic.other-date" | translate }}
              </label>
            </div>
            <div class="flex-item" *ngIf="timeGroup.value.dateOption === 'other'">
              <input
                type="date"
                class="form-control"
                name="date_graph"
                formControlName="date"
                (change)="viewChart(false)"
              />
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="d-flex gap-10 justify-content-center mb-2 flex-wrap">
      <div class="total-values">
        {{ "clients.feed-projection.graph.total-kg-with-ai" | translate }} <b>{{totalDifference | number: '1.0-2'}}kgs</b>
      </div>
      <div class="total-values">
        {{ "clients.feed-projection.graph.ai-percentage" | translate }}
        <b> {{totalDifferencePercent | number: '1.0-2'}}%</b>
      </div>
      <div class="total-values">
        {{ "clients.feed-projection.graph.kg-per-feeder" | translate }}
        <b> {{KgsFeeders | number: '1.0-2'}}Kgs</b>
      </div>
    </div>

    <app-echar [options]="grap_option" [height]="700" [heightStyle]="'px'"></app-echar>
  </div>
</ng-template>

<ng-template #feeding_reports_fuzzy_logic>
  <div class="modal-header d-flex bg-primary p-2 align-items-center text-center">
    <div class="text" style="width: -webkit-fill-available">
      <h3 class="m-0">{{ "view-fuzzy-logic.ai-reports" | translate }}</h3>
    </div>
    <h3 class="m-0 c-pointer" (click)="Modal(feeding_reports_fuzzy_logic, 'hide')">&times;</h3>
  </div>

  <div class="modal-body">
    <div class="filter-container mb-3">
      <form [formGroup]="timeGroup">
        <div class="flex-content">
          <div class="flex-group align-items-center">
            <div class="flex-item">
              <label class="m-0 center gap-6">
                <input
                  type="radio"
                  formControlName="dateOption"
                  value="today"
                  (change)="setValueToday(true);"
                />
                {{ "clients.client-notifications.today" | translate }}
              </label>
            </div>
            <div class="flex-item">
              <label class="m-0 center gap-6">
                <input
                  type="radio"
                  formControlName="dateOption"
                  value="yesterday"
                  (change)="setValueYesterday(true);"
                />
                {{ "view-fuzzy-logic.yesterday" | translate }}
              </label>
            </div>
            <div class="flex-item">
              <label class="m-0 center gap-6">
                <input type="radio" formControlName="dateOption" value="other" />
                {{ "view-fuzzy-logic.other-date" | translate }}
              </label>
            </div>
            <div class="flex-item" *ngIf="timeGroup.value.dateOption === 'other'">
              <input
                type="date"
                class="form-control"
                name="date_graph"
                formControlName="date"
                (change)="getTableFeedingReports()"
              />
            </div>
          </div>
        </div>
      </form>
    </div>

    <table class="table" style="height: 350px; overflow: auto">
      <thead>
        <tr>
          <th scope="col">{{ "tables.creation-date" | translate }}</th>
          <th scope="col">{{ "view-fuzzy-logic.pond-temperature" | translate }}</th>
          <th scope="col">{{ "view-fuzzy-logic.oxygen-level" | translate }}</th>
          <th scope="col">{{ "view-fuzzy-logic.adjustment" | translate }}</th>
          <!--    <th scope="col">Con modificador</th>
          <th scope="col">Sin modificador</th> -->
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of tablefeedingReports">
          <td>{{item.created_at | date: 'medium'}}</td>
          <td>{{item.water_temp}}</td>
          <td>{{item.oxygen_level}}</td>
          <td>{{item.modifier}}</td>
          <!--       <td>{{calculateModifier(item,true)}}</td>
          <td>{{calculateModifier(item,false)}}</td> -->
        </tr>
      </tbody>
    </table>
    <div class="row">
      <div class="col-12 center p-3">
        <app-pagination
          [pageSize]="pageSize"
          [total]="count"
          (event)="getlistpagination($event)"
        ></app-pagination>
      </div>
    </div>
  </div>
</ng-template>
